import { useContext, useEffect } from "react";
import "./StudentMemberPage.scss";
import { Workflow, useTranslator, useNavigator } from "@sia/style-guide";
import { useState } from "react";
import { WizarContext, initialWizardFormState } from "contexts/WizardContext";
import PersonalInfo from "./PersonalInfo";
import SectionInfo from "./Sections";
import CommunicationInfo from "./Communication";
import Summary from "./Summary";
import pgAdapter from "common/Adapters/PGAdapter/PGAdapter";

const StudentMemberPage = () => {
  const translate = useTranslator();
  const { state } = useContext(WizarContext);

  const personalInfo = state.student.personalInfo;
  const sectionInfo = state.student.sectionInfo;
  // const communicationInfo = state.student.sectionInfo;

  const [errors, setErrors] = useState(initialWizardFormState);

  const [currentStepIndex, setCurrentStepIndex] = useState(0);
  const [shouldNavigateToNextStep, setShouldNavigateToNextStep] = useState(true);
  const [step, setStep] = useState(0);
  const navigate = useNavigator();

  const labels = {
    back: translate("wizard.form.single.button.back"),
    next: translate("wizard.form.single.button.next"),
    submit: translate("wizard.form.single.summary.button.label"),
    step: "Step",
    of: "Of",
  };

  const updatePersonalInfoErrors = () => {
    const exculdedProperties = ["phone", "mobile", "email"];
    const optionalProperties = ["additionalInfo"];
    let localShouldNavigateToNextStep = true;
    let personalInfoProperties = initialWizardFormState.student.personalInfo;
    for (let property in personalInfoProperties) {
      if (exculdedProperties.includes(property)) {
        const areSomePropertiesFilled = exculdedProperties.some((exculdedProperty) => personalInfo[exculdedProperty] !== "");
        if (areSomePropertiesFilled) {
          continue;
        } else {
          localShouldNavigateToNextStep = false;
          exculdedProperties.forEach((exculdedProperty) => {
            setErrors((errorState) => ({
              ...errorState,
              student: {
                ...errorState.student,
                personalInfo: { ...errorState.student.personalInfo, [exculdedProperty]: translate("form.input.error.empty") },
              },
            }));
          });
        }
      } else if (
        (personalInfo[property] === "" || personalInfo[property] === null || personalInfo[property] === undefined) &&
        !optionalProperties.includes(property)
      ) {
        localShouldNavigateToNextStep = false;
        setErrors((errorState) => ({
          ...errorState,
          student: {
            ...errorState.student,
            personalInfo: { ...errorState.student.personalInfo, [property]: translate("form.input.error.empty") },
          },
        }));
      }
    }
    setShouldNavigateToNextStep(localShouldNavigateToNextStep);
  };

  const updateSectionInfoErrors = () => {
    let localShouldNavigateToNextStep = true;
    let sectionInfoProperties = initialWizardFormState.student.sectionInfo;
    for (let property in sectionInfoProperties) {
      if (sectionInfo[property] === "" || sectionInfo[property] === null) {
        localShouldNavigateToNextStep = false;
        setErrors((errorState) => ({
          ...errorState,
          student: {
            ...errorState.student,
            sectionInfo: { ...errorState.student.sectionInfo, [property]: translate("form.input.error.empty") },
          },
        }));
      }
    }
    setShouldNavigateToNextStep(localShouldNavigateToNextStep);
  };

  // const updateCommunctionInfoErrors = () => {
  //   let localShouldNavigateToNextStep = true;
  //   for (let property in sectionInfo) {
  //     if (communicationInfo[property] === "" || sectionInfo[property] === null) {
  //       localShouldNavigateToNextStep = false;
  //       setErrors((errorState) => ({
  //         ...errorState,
  //         student: {
  //           ...errorState.single,
  //           communicationInfo: { ...errorState.student.communicationInfo, [property]: translate("form.input.error.empty") },
  //         },
  //       }));
  //     }
  //   }
  //   setShouldNavigateToNextStep(localShouldNavigateToNextStep);
  // };

  const checkForFormsError = () => {
    if (currentStepIndex === 0) {
      updatePersonalInfoErrors();
    }
    if (currentStepIndex === 1) {
      updateSectionInfoErrors();
    }
    // if (currentStepIndex === 2) {
    //   updateCommunctionInfoErrors();
    // }
  };

  const steps = [
    {
      label: translate("wizard.form.single.personal-info.label"),
      content: <PersonalInfo errors={errors} setErrors={setErrors} />,
    },
    { label: translate("wizard.form.single.sections.label"), content: <SectionInfo errors={errors} setErrors={setErrors} /> },
    { label: translate("wizard.form.single.communication.title"), content: <CommunicationInfo errors={errors} setErrors={setErrors} /> },
    { label: translate("wizard.form.single.summary.label"), content: <Summary /> },
  ];

  useEffect(() => {
    if (shouldNavigateToNextStep) {
      setCurrentStepIndex(step);
    }
    if (step < currentStepIndex && !shouldNavigateToNextStep) {
      setShouldNavigateToNextStep(true);
    }
  }, [step, shouldNavigateToNextStep, currentStepIndex]);

  function submitForm() {
    let body = { form_data: { ...state.student, is_student: true } };
    pgAdapter.request("POST", "member_subscription/register_single", body, (data) => {
      if (data.status === 200) {
        navigate("");
      } else {
        // NOW WHAT?
      }
    });
  }

  return (
    <div className="single-member-page">
      <h3 className="single-member-page__heading productive-heading-04 sia-text-12 sia-margin-06-top sia-margin-05-bottom">
        {translate("wizard.registeration-options.no-diploma.button.label")}
      </h3>
      <Workflow
        steps={steps}
        labels={labels}
        slimContent={true}
        currentStepIndex={currentStepIndex}
        onNavigate={(newStepIndex) => {
          checkForFormsError();
          setStep(newStepIndex);
        }}
        onSubmit={() => submitForm()}
      />
    </div>
  );
};

export default StudentMemberPage;
